import * as n from "react";
import { c as H, a as p, u as V } from "./index.stoqs9MZ.js";
import { c as z } from "./index.BW3XI7yS.js";
import { u as q } from "./index.B4ZV02se.js";
import { u as J } from "./index.BUG7NYeV.js";
import { P as G } from "./index.DMLWxr4u.js";
import { u as Q } from "./index.BhJrV2wu.js";
import { j as d } from "./jsx-runtime.DGlMoOmv.js";
function W(e) {
  const o = n.useRef(e);
  return n.useEffect(() => {
    o.current = e;
  }), n.useMemo(() => (...s) => o.current?.(...s), []);
}
var _ = "rovingFocusGroup.onEntryFocus", X = { bubbles: !1, cancelable: !0 }, I = "RovingFocusGroup", [y, N, Z] = z(I), [$, ve] = H(
  I,
  [Z]
), [ee, oe] = $(I), O = n.forwardRef(
  (e, o) => /* @__PURE__ */ d.jsx(y.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d.jsx(y.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d.jsx(te, { ...e, ref: o }) }) })
);
O.displayName = I;
var te = n.forwardRef((e, o) => {
  const {
    __scopeRovingFocusGroup: s,
    orientation: t,
    loop: T = !1,
    dir: w,
    currentTabStopId: v,
    defaultCurrentTabStopId: C,
    onCurrentTabStopIdChange: S,
    onEntryFocus: m,
    preventScrollOnEntryFocus: u = !1,
    ...b
  } = e, F = n.useRef(null), R = q(o, F), g = Q(w), [E, r] = V({
    prop: v,
    defaultProp: C ?? null,
    onChange: S,
    caller: I
  }), [i, h] = n.useState(!1), a = W(m), l = N(s), x = n.useRef(!1), [k, P] = n.useState(0);
  return n.useEffect(() => {
    const c = F.current;
    if (c)
      return c.addEventListener(_, a), () => c.removeEventListener(_, a);
  }, [a]), /* @__PURE__ */ d.jsx(
    ee,
    {
      scope: s,
      orientation: t,
      dir: g,
      loop: T,
      currentTabStopId: E,
      onItemFocus: n.useCallback(
        (c) => r(c),
        [r]
      ),
      onItemShiftTab: n.useCallback(() => h(!0), []),
      onFocusableItemAdd: n.useCallback(
        () => P((c) => c + 1),
        []
      ),
      onFocusableItemRemove: n.useCallback(
        () => P((c) => c - 1),
        []
      ),
      children: /* @__PURE__ */ d.jsx(
        G.div,
        {
          tabIndex: i || k === 0 ? -1 : 0,
          "data-orientation": t,
          ...b,
          ref: R,
          style: { outline: "none", ...e.style },
          onMouseDown: p(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: p(e.onFocus, (c) => {
            const L = !x.current;
            if (c.target === c.currentTarget && L && !i) {
              const D = new CustomEvent(_, X);
              if (c.currentTarget.dispatchEvent(D), !D.defaultPrevented) {
                const A = l().filter((f) => f.focusable), U = A.find((f) => f.active), B = A.find((f) => f.id === E), Y = [U, B, ...A].filter(
                  Boolean
                ).map((f) => f.ref.current);
                j(Y, u);
              }
            }
            x.current = !1;
          }),
          onBlur: p(e.onBlur, () => h(!1))
        }
      )
    }
  );
}), K = "RovingFocusGroupItem", M = n.forwardRef(
  (e, o) => {
    const {
      __scopeRovingFocusGroup: s,
      focusable: t = !0,
      active: T = !1,
      tabStopId: w,
      children: v,
      ...C
    } = e, S = J(), m = w || S, u = oe(K, s), b = u.currentTabStopId === m, F = N(s), { onFocusableItemAdd: R, onFocusableItemRemove: g, currentTabStopId: E } = u;
    return n.useEffect(() => {
      if (t)
        return R(), () => g();
    }, [t, R, g]), /* @__PURE__ */ d.jsx(
      y.ItemSlot,
      {
        scope: s,
        id: m,
        focusable: t,
        active: T,
        children: /* @__PURE__ */ d.jsx(
          G.span,
          {
            tabIndex: b ? 0 : -1,
            "data-orientation": u.orientation,
            ...C,
            ref: o,
            onMouseDown: p(e.onMouseDown, (r) => {
              t ? u.onItemFocus(m) : r.preventDefault();
            }),
            onFocus: p(e.onFocus, () => u.onItemFocus(m)),
            onKeyDown: p(e.onKeyDown, (r) => {
              if (r.key === "Tab" && r.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (r.target !== r.currentTarget) return;
              const i = se(r, u.orientation, u.dir);
              if (i !== void 0) {
                if (r.metaKey || r.ctrlKey || r.altKey || r.shiftKey) return;
                r.preventDefault();
                let a = F().filter((l) => l.focusable).map((l) => l.ref.current);
                if (i === "last") a.reverse();
                else if (i === "prev" || i === "next") {
                  i === "prev" && a.reverse();
                  const l = a.indexOf(r.currentTarget);
                  a = u.loop ? ce(a, l + 1) : a.slice(l + 1);
                }
                setTimeout(() => j(a));
              }
            }),
            children: typeof v == "function" ? v({ isCurrentTabStop: b, hasTabStop: E != null }) : v
          }
        )
      }
    );
  }
);
M.displayName = K;
var re = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function ne(e, o) {
  return o !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function se(e, o, s) {
  const t = ne(e.key, s);
  if (!(o === "vertical" && ["ArrowLeft", "ArrowRight"].includes(t)) && !(o === "horizontal" && ["ArrowUp", "ArrowDown"].includes(t)))
    return re[t];
}
function j(e, o = !1) {
  const s = document.activeElement;
  for (const t of e)
    if (t === s || (t.focus({ preventScroll: o }), document.activeElement !== s)) return;
}
function ce(e, o) {
  return e.map((s, t) => e[(o + t) % e.length]);
}
var Ie = O, be = M;
export {
  be as I,
  Ie as R,
  ve as c
};
//# sourceMappingURL=index.BwKnBOdH.js.map
